import React from 'react';
import NavbarLinks from 'layouts/Navbar/NavbarLinks';
import NavbarLogo from 'layouts/Navbar/NavbarLogo';
import NavbarMobileLinks from 'layouts/Navbar/NavbarMobileLinks';
import pages from 'pages';

import { AppBar, Container, Toolbar } from '@mui/material';

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position='static'>
      <Container maxWidth='xl'>
        <Toolbar style={styles.box} disableGutters>
          <NavbarLogo label='Hayk Simonyan' url='/' />

          <NavbarMobileLinks
            pages={pages}
            anchorEl={anchorElNav}
            onIconClick={handleOpenNavMenu}
            onNavClose={handleCloseNavMenu}
          />
          <NavbarLinks pages={pages} />
        </Toolbar>
      </Container>
    </AppBar>
  );
};

const styles = {
  box: {
    display: 'flex',
  },
};

export default Navbar;
